import { SxProps, Theme } from "@mui/material";

// Shared styling for the icon buttons in a data grid's actions column, so they read the same as the
// round action/delete buttons used in the learning galleries: white-on-blue for actions, white-on-red
// for deletes. Applied via the `sx` prop of each GridActionsCellItem.
export const gridActionSx: SxProps<Theme> = {
  bgcolor: "primary.main",
  color: "common.white",
  boxShadow: 2,
  "&:hover": { bgcolor: "primary.dark", boxShadow: 4 },
};

export const gridDeleteSx: SxProps<Theme> = {
  bgcolor: "error.main",
  color: "common.white",
  boxShadow: 2,
  "&:hover": { bgcolor: "error.dark", boxShadow: 4 },
};
